import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import {
  MatRowDef,
  MatTableModule,
} from "@angular/material/table";
import { MatDialogModule, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CommonModule, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatOptionModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import {
  NgSelectModule,
} from "@ng-select/ng-select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from 'app/utils/method';
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { GroupUnitMeasureService } from "./material-group-unit-measurement.service";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { NoFiltersAvailableComponent } from "app/common/components/no-filters-available/no-filters-available.component";
import UnitMeasurementsGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements-group/unit-measurements-group.entity";
import { ICreateMaterialGroupUnitMeasurement } from "./interfaces/material-group-unit-measurement.interface";
import { GroupUnitMeasurementExport } from "./exports/group-unit-measurement.export";
import { ExportDialogComponent, ExportOptions } from "app/layout/export-overlay";
import { UNIT_OF_MEASUREMENT_GROUP_TITLE } from "./exports/group-unit-measurement.constants";
import { IPaginationResult } from "app/common/interfaces";
import { UnitMeasurementGroupEnum } from "./material-group-unit.enum";

@Component({
  selector: "app-material-group-unit-measurement",
  templateUrl: "./material-group-unit-measurement.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    MatTabsModule,
    StatusFiltersComponent,
    FilterComponent,
    NoFiltersAvailableComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    GroupUnitMeasurementExport
  ],
})
export class MaterialGroupUnitMeasurementComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  
  displayedColumns: string[] = ["name", "status", "actions"];
  dataSource: UnitMeasurementsGroupAttributes[] = [];
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof UnitMeasurementsGroupAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  public id: string = null
  currentGroupUnitOfMeasure: ICreateMaterialGroupUnitMeasurement = this.initializeCreateMaterialGroupUnitOfMeasure();
  canEdit = true;

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef:MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];

  constructor(
    private readonly groupUnitService: GroupUnitMeasureService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private groupUnitMeasurementExport: GroupUnitMeasurementExport,
  ) {}

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.findAllWithCount();
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.search = term;
        if (this.search.length >= 2 || this.search.length === 0) {
          this.findAllWithCount();
        }
      });
  }

  findAllWithCount(): void {
    const sortField = this.getSortField();
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: sortField, sortDirection: this.sortDirection }

    this.groupUnitService
      .findAllWithCount(options, this.selectedStatuses)
      .subscribe({
        next: (data: IPaginationResult<UnitMeasurementsGroupAttributes>) => {
          this.dataSource = data?.data?.[0]?.data ?? [];
          this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        },
        error: (err) => {
          this.snackBar.open(
            err?.error?.message || "Error al cargar los registros", "Cerrar", { duration: 3000 }
          );
        }
      });
  }

  private getSortField(): keyof UnitMeasurementsGroupAttributes {
    const sortFieldMapping: Record<string, keyof UnitMeasurementsGroupAttributes> = {
      name: "name",
      code: "code"
    }
    return sortFieldMapping[this.sortActive] || "name";
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.findAllWithCount()
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  clearFilters(): void {
    this.search = "";
    this.findAllWithCount();
  }

  onStatusChange(event: boolean, unitGroup: UnitMeasurementsGroupAttributes): void {
    const originalStatusId = unitGroup.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedGroupUnitOfMeasure = { ...unitGroup, statusId: updatedStatusId };

    this.groupUnitService
      .update(unitGroup._id.toString(), updatedGroupUnitOfMeasure)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          unitGroup.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  isDisabled(element: UnitMeasurementsGroupAttributes): boolean {
    const defaultCodes: UnitMeasurementGroupEnum[] = [
      UnitMeasurementGroupEnum.VOLUME,
      UnitMeasurementGroupEnum.LENGTH,
      UnitMeasurementGroupEnum.MASS
    ];
    return defaultCodes.includes(element.code as UnitMeasurementGroupEnum);
  }

  //#region Modal
  private initializeCreateMaterialGroupUnitOfMeasure(): ICreateMaterialGroupUnitMeasurement {
    return { name: "", code:"" };
  }

  openModal(unitGroup?: UnitMeasurementsGroupAttributes): void {
    if(unitGroup){
      this.currentGroupUnitOfMeasure = {
        ...unitGroup,        
      };
      this.id = String(unitGroup._id)
      this.canEdit = !this.isDisabled(unitGroup)
    }else{
      this.currentGroupUnitOfMeasure = this.initializeCreateMaterialGroupUnitOfMeasure();
      this.id = null
    }

    this.dialogRef = this.dialog.open(this.actionModal, { panelClass: "form-modal",disableClose:true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit(){
    if (!this.canEdit) {
      this.snackBar.open(
        "No se pueden realizar modificaciones en el estado actual del viaje",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    if(this.id == null){
      this.createUnitOfMeasuregGroup()
    }else{
      this.updateUnitOfMeasureGroup(this.id)
    }
  }

  createUnitOfMeasuregGroup(): void {
    this.groupUnitService.create(this.currentGroupUnitOfMeasure).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRef.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateUnitOfMeasureGroup(id: string): void {
    if (this.currentGroupUnitOfMeasure) {
      const updatedUnitOfMeasure: UnitMeasurementsGroupAttributes = { 
        ...this.currentGroupUnitOfMeasure,
      };

      this.groupUnitService.update(id, updatedUnitOfMeasure).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRef.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  openDeleteDialog(unitGroup: UnitMeasurementsGroupAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: unitGroup, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe({
        next: (result) => {
          if (result && unitGroup?._id) {
            this.delete(unitGroup._id.toString());
          } else if (result) {
            this.snackBar.open("Registro inválido, no se pudo eliminar", "Cerrar", { duration: 3000 });
          }
        },
        error: (err) => {
         this.snackBar.open(
            err?.error?.message || "Error al cerrar el diálogo","Cerrar", { duration: 3000 }
          );
        }
      });
  }

  delete(id: string): void {
    this.groupUnitService.remove(id).subscribe({
      next: () => {
        this.findAllWithCount();
        this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
      },
      error: (err) => {
        this.snackBar.open(
          err?.error?.message || "Error al eliminar el registro", "Cerrar", { duration: 3000 }
        );
      }
    });
  }
  //#endregion

  //#region Exportar
  onExportButtonPressed() {
    if (!this.groupUnitMeasurementExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: UNIT_OF_MEASUREMENT_GROUP_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.groupUnitMeasurementExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }
  //#endregion

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
